export default function isConsentResolved() {
  return Boolean(window.Termly?.getConsentState())
}
